import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollManager(){
  const location = useLocation();

  // On route change: if there is no explicit scroll target in navigation state,
  // jump to top before paint. If there is a scroll target, the destination page
  // will handle the jump synchronously.
  useLayoutEffect(()=>{
    const hasTarget = !!(location && location.state && location.state.scrollToId);
    if(!hasTarget){
      try{ window.scrollTo(0,0); }catch(e){}
    }
  }, [location.pathname]);

  return null;
}
